import React from "react";
import {createActions} from "./actions";
import useAsyncReducer from "../../hooks/useAsyncReducer";
import reducer, {initialState} from "./reducer";

export const CustomerContext = React.createContext();

export const CustomerProvider = ({children}) => {
  const [state, dispatch] = useAsyncReducer(reducer, initialState);
  const actions = createActions(dispatch);

  return (
    <CustomerContext.Provider value={[state, actions]}>
      {children}
    </CustomerContext.Provider>
  );
};
